// extracted by mini-css-extract-plugin
export default {"header":"EducationCoursePageHeader_header__7H+Fy","headerEmbedded":"EducationCoursePageHeader_headerEmbedded__8UIqL","headerCompact":"EducationCoursePageHeader_headerCompact__Z-eAA"};